import { Url } from '../../types/basic';
import { DocumentPage } from './DocumentPage';
import { useLastRotation } from './useLastRotation';

type OriginalDocumentPageProps = {
  pageUrl: Url;
  pageNumber: number;
  isCurrent: boolean;
  onClick: () => void;
  rotationDeg: number;
};

export const OriginalDocumentPage = ({
  isCurrent,
  pageUrl,
  pageNumber,
  onClick,
  rotationDeg,
}: OriginalDocumentPageProps) => {
  const lastCssRotation = useLastRotation(rotationDeg);

  return (
    <DocumentPage
      pageUrl={pageUrl}
      pageNumber={pageNumber}
      isCurrent={isCurrent}
      onClick={onClick}
      rotationDeg={lastCssRotation.current}
      blackOverlay={0}
    />
  );
};
